import { render, staticRenderFns } from "./CockpitMatryoshkaItemDetailsTab.vue?vue&type=template&id=03916c04&scoped=true"
import script from "./CockpitMatryoshkaItemDetailsTab.vue?vue&type=script&lang=js"
export * from "./CockpitMatryoshkaItemDetailsTab.vue?vue&type=script&lang=js"
import style0 from "./CockpitMatryoshkaItemDetailsTab.vue?vue&type=style&index=0&id=03916c04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03916c04",
  null
  
)

export default component.exports